import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import {useSelector } from "react-redux";
import { Frequencies, FrequencyValues,BotTypeName, FrequenciesPro, FrequencyValuesPro } from "../../../Const";
import LeftRightForm from "../new-bot/modules/LeftRightForm";

const CommonBotSettings = (props) => {
  const { bot,t } = props;
  return (
      <>
       <div className="col-6">
                  <div className="bdol-item">
                    <span>{t("bot-type")}</span>
                    <h6>{bot && BotTypeName[bot.type]}</h6>
                  </div>
                </div>
                <div className="col-6">
                  <div className="bdol-item">
                    <span>{t("strategy")}</span>
                    <h6 >{bot && bot.strategy}</h6>
                  </div>
                </div>
                <div className="col-6">
                  <div className="bdol-item">
                    <span>{t("Frequency")}</span>
                    <h6>{bot && FrequenciesPro[FrequencyValuesPro.indexOf(bot.frequency)]}</h6>
                  </div>
                </div>
            <div className="col-6">
              <div className="bdol-item">
                <span>{t("Allocated Fund")}</span>
                <h6>{bot && `${bot.initial_fund}`}</h6>
              </div>
            </div>
              
        </>
  );
};

export default CommonBotSettings;
